/* Aliangé — How to use (/pages/using-aliange)
 * ---------------------------------------------------------------
 * Owns the protocol selector, the AM/PM/treatment tabs, the "new to
 * actives" ramp toggle, the URL hash, localStorage persistence, the
 * print view, the sticky bar and the HowTo/FAQ structured data.
 *
 * Data comes from #ali-htu-data, rendered by
 * snippets/aliange-how-to-use-data.liquid. Gated clinical lines are
 * filtered server-side in Liquid; this file must never re-add them.
 *
 * Vanilla ES2018. No dependencies. Deferred.
 */
(function () {
  'use strict';

  var root = document.getElementById('ali-htu');
  var dataEl = document.getElementById('ali-htu-data');
  if (!root || !dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // leave the server-rendered copy and the noscript list standing
  }

  var STORE_KEY = 'ali_protocol';
  var RAMP_KEY = 'ali_protocol_ramp';
  var products = DATA.products;
  var protocols = DATA.protocols;
  var order = DATA.protocolOrder;

  var state = {
    protocol: null,
    tab: null,
    mode: null,
    ramp: false
  };

  /* ── storage helpers (private windows and blocked site data throw) ── */
  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* no-op */ }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
  function $(id) { return document.getElementById(id); }

  function phaseLabel(id) {
    for (var i = 0; i < DATA.phases.length; i++) {
      if (DATA.phases[i].id === id) return DATA.phases[i].label;
    }
    return '';
  }

  function currentTab() {
    var p = protocols[state.protocol];
    for (var i = 0; i < p.tabs.length; i++) {
      if (p.tabs[i].id === state.tab) return p.tabs[i];
    }
    return p.tabs[0];
  }

  /* Steps for the active tab, honouring the Acne PM treatment/other modes. */
  function currentSteps() {
    var tab = currentTab();
    if (tab.modes) {
      for (var i = 0; i < tab.modes.length; i++) {
        if (tab.modes[i].id === state.mode) return tab.modes[i];
      }
      return tab.modes[0];
    }
    return tab;
  }

  // "the The Protocol" reads wrong; names beginning with "The" already have it.
  function article(name) {
    return (/^the\b/i.test(name) ? '' : 'the ') + name;
  }

  function rampFor(productKey) {
    var p = protocols[state.protocol];
    if (p.ramp && p.ramp[productKey]) return p.ramp[productKey];
    if (products[productKey] && products[productKey].ramp) return products[productKey].ramp;
    return null;
  }

  /* ── Selector ─────────────────────────────────────────
     The cards are server-rendered (see the section's sel_rows) so the hero
     does not reflow on boot. This only binds behaviour. */
  function buildSelector() {
    var wrap = $('ali-htu-selector');

    wrap.addEventListener('click', function (ev) {
      var card = ev.target.closest ? ev.target.closest('.sel-card[data-protocol]') : null;
      if (!card) return;
      select(card.dataset.protocol, true);
    });

    wrap.addEventListener('keydown', function (ev) {
      var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
      if (keys.indexOf(ev.key) === -1) return;
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('.sel-card[data-protocol]'));
      var idx = cards.indexOf(document.activeElement);
      if (idx === -1) return;
      ev.preventDefault();
      var step = (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') ? 1 : -1;
      var next = cards[(idx + step + cards.length) % cards.length];
      next.focus();
      select(next.dataset.protocol, true);
    });
  }

  function paintSelector() {
    var cards = $('ali-htu-selector').querySelectorAll('.sel-card[data-protocol]');
    Array.prototype.forEach.call(cards, function (c) {
      var on = c.dataset.protocol === state.protocol;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });
  }

  /* ── Tabs + modes ─────────────────────────────────────── */
  function renderTabs() {
    var p = protocols[state.protocol];
    var wrap = $('ali-htu-tabs');
    clear(wrap);

    if (p.tabs.length > 1) {
      p.tabs.forEach(function (t) {
        var b = el('button', 'tab', t.label);
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', t.id === state.tab ? 'true' : 'false');
        b.tabIndex = t.id === state.tab ? 0 : -1;
        b.dataset.tab = t.id;
        b.addEventListener('click', function () {
          state.tab = t.id;
          state.mode = null;
          renderProtocol();
        });
        wrap.appendChild(b);
      });
      wrap.hidden = false;
    } else {
      var only = el('span', 'tab');
      only.setAttribute('aria-selected', 'true');
      only.setAttribute('role', 'tab');
      only.textContent = p.tabs[0].label;
      wrap.appendChild(only);
      wrap.hidden = false;
    }

    var modeWrap = $('ali-htu-modes');
    clear(modeWrap);
    var tab = currentTab();
    if (tab.modes) {
      var row = el('div', 'modes');
      tab.modes.forEach(function (m) {
        var b = el('button', 'mode', m.label);
        b.type = 'button';
        b.setAttribute('aria-pressed', m.id === state.mode ? 'true' : 'false');
        b.addEventListener('click', function () {
          state.mode = m.id;
          renderProtocol();
        });
        row.appendChild(b);
      });
      modeWrap.appendChild(row);
    }
  }

  /* ── Steps ────────────────────────────────────────────── */
  function renderSteps() {
    var wrap = $('ali-htu-steps');
    clear(wrap);
    var active = currentSteps();

    active.steps.forEach(function (s, i) {
      var prod = products[s.p];
      if (!prod) return;

      var row = el('div', 'step');

      var num = el('div', 'num');
      num.appendChild(document.createTextNode(String(i + 1).padStart(2, '0')));
      num.appendChild(el('small', null, s.label || phaseLabel(prod.phase)));
      row.appendChild(num);

      var thumbCell = el('div', 'thumbcell');
      var tile = el('div', 'tile');
      var img = document.createElement('img');
      img.className = 'thumb';
      img.src = prod.image || prod.fallbackImage;
      img.alt = '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      img.decoding = 'async';
      tile.appendChild(img);
      thumbCell.appendChild(tile);

      var name = el('div', 'name');
      var link = el('a', null, prod.name);
      link.href = prod.url;
      name.appendChild(link);
      if (prod.size) name.appendChild(el('span', 'sz', prod.size));
      thumbCell.appendChild(name);
      row.appendChild(thumbCell);

      var body = el('div', 'body');

      if (s.alt) body.appendChild(el('p', null, s.alt));

      var amountLine = el('p');
      amountLine.appendChild(el('span', 'amount', prod.amount));
      amountLine.appendChild(document.createTextNode('. ' + prod.method));
      body.appendChild(amountLine);

      // Only a product with a ramp rule for THIS protocol defers its frequency;
      // the cleanser and the barrier serum stay at their steady state from day one.
      var ramp = state.ramp ? rampFor(s.p) : null;

      var meta = el('div', 'meta');
      if (prod.wait) {
        meta.appendChild(el('span', null, 'Then wait'));
        meta.appendChild(el('b', null, prod.wait));
      }
      meta.appendChild(el('span', null, 'How often'));
      meta.appendChild(el('b', null, ramp ? 'Building up, see the schedule below' : prod.frequency));
      body.appendChild(meta);

      if (prod.cautions && prod.cautions.length) {
        var c = el('div', 'caution');
        prod.cautions.forEach(function (item) { c.appendChild(el('p', null, item.text)); });
        body.appendChild(c);
      }

      if (ramp) {
        var box = el('div', 'ramp');
        [
          ['Weeks 1 to 2', ramp.w12],
          ['Weeks 3 to 4', ramp.w34],
          ['Weeks 5 to 6', ramp.w56],
          ['From week 7', ramp.w7]
        ].forEach(function (pair) {
          var r = el('div', 'ramp-row');
          r.appendChild(el('span', 'w', pair[0]));
          r.appendChild(el('span', 'v', pair[1]));
          box.appendChild(r);
        });
        body.appendChild(box);
      }

      if (prod.why) {
        var det = el('details', 'why');
        det.appendChild(el('summary', null, 'Why this step'));
        det.appendChild(el('p', 'why-body', prod.why));
        body.appendChild(det);
      }

      row.appendChild(body);
      wrap.appendChild(row);
    });
  }

  /* ── Add a layer ──────────────────────────────────────── */
  function renderLayers() {
    var p = protocols[state.protocol];
    var section = $('ali-htu-layers-section');
    var wrap = $('ali-htu-layers');
    var pairWrap = $('ali-htu-pairlist');
    var lede = $('ali-htu-layers-lede');
    var heading = $('ali-htu-layers-h');
    clear(wrap);
    clear(pairWrap);

    if (p.isLayer) {
      heading.innerHTML = 'Pair with a <strong>daily protocol</strong>.';
      lede.textContent = p.name + ' layers onto a daily protocol rather than replacing one. Choose the daily protocol it sits on.';
      (p.pairWith || []).forEach(function (key) {
        var b = el('button', null, protocols[key].name + ' ↗');
        b.type = 'button';
        b.addEventListener('click', function () { select(key, true); });
        pairWrap.appendChild(b);
      });
      section.hidden = false;
      return;
    }

    var addons = (p.addons || []).filter(function (k) { return k !== state.protocol; });
    if (!addons.length) {
      section.hidden = true;
      return;
    }

    heading.innerHTML = 'Add a <strong>layer</strong>.';
    lede.textContent = 'These layer onto ' + article(p.name) + ' without changing its order.';

    addons.forEach(function (key) {
      var a = protocols[key];
      var card = el('div', 'layer');
      card.appendChild(el('div', 'where', a.cadence));
      var h = el('h3');
      h.textContent = a.name;
      card.appendChild(h);
      card.appendChild(el('p', null, DATA.addonCopy[key] || a.prescribedFor));
      var link = el('button', 'link');
      link.type = 'button';
      link.innerHTML = 'See the ' + a.name + ' steps <span aria-hidden="true">↗</span>';
      link.addEventListener('click', function () { select(key, true); });
      card.appendChild(link);
      wrap.appendChild(card);
    });

    section.hidden = false;
  }

  /* ── Bottle life ──────────────────────────────────────
     One figure for every SKU, so the only per-protocol part is which
     formulations it covers. */
  function renderLife() {
    var count = $('ali-htu-life-count');
    if (!count) return;
    var seen = {}, names = [];
    protocols[state.protocol].tabs.forEach(function (tab) {
      (tab.modes ? tab.modes : [tab]).forEach(function (l) {
        l.steps.forEach(function (st) {
          if (seen[st.p] || !products[st.p]) return;
          seen[st.p] = true;
          names.push(products[st.p].name);
        });
      });
    });
    if (!names.length) { count.textContent = ''; return; }
    var list = names.length > 1
      ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1]
      : names[0];
    count.textContent = 'In this protocol: ' + list + '.';
  }

  /* ── Static blocks (rules, timeline) ──────────────────── */
  function renderStatic() {
    var rules = $('ali-htu-rules');
    clear(rules);
    DATA.rules.forEach(function (r, i) {
      var card = el('div', 'rule');
      card.appendChild(el('div', 'rn', String(i + 1).padStart(2, '0')));
      card.appendChild(el('p', null, r.text));
      rules.appendChild(card);
    });

    var tl = $('ali-htu-timeline');
    clear(tl);
    DATA.timeline.forEach(function (t) {
      var card = el('div', 'tier');
      card.appendChild(el('div', 'when', t.when));
      card.appendChild(el('p', null, t.what));
      tl.appendChild(card);
    });
  }

  /* ── Print view ───────────────────────────────────────
     The screen shows one tab at a time. A printout has to carry the whole
     protocol, so this rebuilds every application (AM, PM, treatment nights)
     as one compact list plus the rules. Called on beforeprint, so it always
     matches the protocol currently selected. */
  function renderPrintView() {
    var wrap = $('ali-htu-print-view');
    if (!wrap) return;
    clear(wrap);
    var p = protocols[state.protocol];

    p.tabs.forEach(function (tab) {
      var lists = tab.modes ? tab.modes : [tab];
      lists.forEach(function (l) {
        wrap.appendChild(el('p', 'pv-app', tab.modes ? tab.label + ' — ' + l.label : l.label || tab.label));
        var note = l.note || tab.note;
        if (note) wrap.appendChild(el('p', 'pv-note', note));

        var ol = el('ol');
        l.steps.forEach(function (st) {
          var prod = products[st.p];
          if (!prod) return;
          var li = el('li');
          li.appendChild(el('span', 'pv-ph', (st.label || phaseLabel(prod.phase)) + ' · '));
          li.appendChild(el('b', null, prod.name));
          var tail = '. ' + prod.amount + '. ' + prod.method;
          if (prod.wait) tail += ' Then wait ' + prod.wait.toLowerCase() + '.';
          tail += ' ' + prod.frequency + '.';
          (prod.cautions || []).forEach(function (c) { tail += ' ' + c.text; });
          li.appendChild(document.createTextNode(tail));
          ol.appendChild(li);
        });
        wrap.appendChild(ol);
      });
    });

    var rules = el('div', 'pv-rules');
    rules.appendChild(el('p', 'pv-app', 'Rules of the protocol'));
    var rol = el('ol');
    DATA.rules.forEach(function (r) { rol.appendChild(el('li', null, r.text)); });
    rules.appendChild(rol);
    wrap.appendChild(rules);
  }

  /* ── Structured data ──────────────────────────────────── */
  function buildSchema() {
    var node = $('ali-htu-schema');
    if (!node) return;
    var origin = window.location.origin;
    var graph = [];

    order.forEach(function (key) {
      var p = protocols[key];
      var supply = {};
      var sections = [];

      p.tabs.forEach(function (tab) {
        var lists = tab.modes ? tab.modes : [tab];
        lists.forEach(function (l) {
          var steps = l.steps.map(function (s, i) {
            var prod = products[s.p];
            supply[s.p] = prod.name;
            return {
              '@type': 'HowToStep',
              position: i + 1,
              name: (s.label || phaseLabel(prod.phase)) + ': ' + prod.name,
              text: prod.amount + '. ' + prod.method,
              url: origin + window.location.pathname + '#' + key
            };
          });
          sections.push({
            '@type': 'HowToSection',
            name: p.name + ', ' + (l.label || tab.label),
            itemListElement: steps
          });
        });
      });

      var howto = {
        '@type': 'HowTo',
        '@id': origin + window.location.pathname + '#' + key,
        name: 'How to use the ' + p.name,
        description: p.prescribedFor,
        supply: Object.keys(supply).map(function (k) {
          return { '@type': 'HowToSupply', name: supply[k] };
        }),
        step: sections
      };
      if (p.totalTime) howto.totalTime = p.totalTime;
      graph.push(howto);
    });

    graph.push({
      '@type': 'FAQPage',
      mainEntity: DATA.rules.filter(function (r) { return r.q; }).map(function (r) {
        return {
          '@type': 'Question',
          name: r.q,
          acceptedAnswer: { '@type': 'Answer', text: r.text }
        };
      })
    });

    node.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
  }

  /* ── Render + select ──────────────────────────────────── */
  function renderProtocol() {
    var p = protocols[state.protocol];

    // A tab with modes (the Acne evening) must always have one selected.
    var t = currentTab();
    if (t.modes) {
      var valid = t.modes.some(function (m) { return m.id === state.mode; });
      if (!valid) state.mode = t.modes[0].id;
    } else {
      state.mode = null;
    }

    $('ali-htu-name').textContent = p.name;
    $('ali-htu-for').textContent = 'Prescribed for: ' + p.prescribedFor;

    renderTabs();

    var active = currentSteps();
    var note = active.note || currentTab().note || '';
    var tabnote = $('ali-htu-tabnote');
    tabnote.textContent = note
      ? note + ' Apply in this order, allowing each layer 30 to 60 seconds before the next.'
      : 'Apply in this order. Allow each layer 30 to 60 seconds before the next.';

    renderSteps();
    renderLayers();
    renderLife();

    var cta = $('ali-htu-bundle');
    cta.href = p.bundleUrl;
    // "Shop the The Protocol" - names that already carry the article skip it.
    var lead = /^the\b/i.test(p.name) ? 'Shop ' : 'Shop the ';
    cta.innerHTML = lead + p.name + (p.bundlePrice ? ', ' + p.bundlePrice : '') + ' <span aria-hidden="true">↗</span>';

    var sticky = $('ali-htu-sticky-name');
    if (sticky) sticky.textContent = p.name;

    if (p.completionPath) {
      var fine = $('ali-htu-hero-fine');
      fine.textContent = p.completionPath + ' ';
      var a = el('button', 'link');
      a.type = 'button';
      a.innerHTML = 'See the ' + protocols[p.completionTarget].name + ' <span aria-hidden="true">↗</span>';
      a.addEventListener('click', function () { select(p.completionTarget, true); });
      fine.appendChild(a);
    } else {
      $('ali-htu-hero-fine').innerHTML =
        'Not sure which is yours? <a class="link" href="' + DATA.settings.quizUrl + '">Find my protocol <span aria-hidden="true">↗</span></a>';
    }

    paintSelector();
  }

  function select(key, pushHash) {
    if (!protocols[key]) key = DATA.settings.defaultProtocol;
    if (!protocols[key]) key = order[0];

    state.protocol = key;
    var p = protocols[key];
    var hasTab = p.tabs.some(function (t) { return t.id === state.tab; });
    if (!hasTab) state.tab = p.defaultTab;
    state.mode = null;

    var tab = currentTab();
    if (tab.modes && !state.mode) state.mode = tab.modes[0].id;

    write(STORE_KEY, key);
    if (pushHash && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + key);
    }
    renderProtocol();
  }

  /* ── Boot ─────────────────────────────────────────────── */
  function boot() {
    root.dataset.js = 'true';

    buildSelector();
    renderStatic();

    state.ramp = read(RAMP_KEY) === '1';
    var rampBtn = $('ali-htu-ramp');
    rampBtn.setAttribute('aria-pressed', state.ramp ? 'true' : 'false');
    rampBtn.addEventListener('click', function () {
      state.ramp = !state.ramp;
      rampBtn.setAttribute('aria-pressed', state.ramp ? 'true' : 'false');
      write(RAMP_KEY, state.ramp ? '1' : '0');
      renderSteps();
    });

    var printBtn = $('ali-htu-print');
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
    window.addEventListener('beforeprint', renderPrintView);

    var hash = (window.location.hash || '').replace('#', '');
    var initial = protocols[hash] ? hash : (protocols[read(STORE_KEY)] ? read(STORE_KEY) : DATA.settings.defaultProtocol);
    select(initial, false);

    window.addEventListener('hashchange', function () {
      var h = (window.location.hash || '').replace('#', '');
      if (protocols[h] && h !== state.protocol) select(h, false);
    });

    buildSchema();
    setupSticky();
    setupReveal();
  }

  function setupSticky() {
    var bar = $('ali-htu-sticky');
    if (!bar || root.dataset.sticky !== 'true') return;
    bar.hidden = false;

    var hero = $('ali-htu-top');
    var change = bar.querySelector('[data-htu-change]');
    if (change) {
      change.addEventListener('click', function () {
        hero.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
        var first = $('ali-htu-selector').querySelector('.sel-card[aria-checked="true"]');
        if (first) first.focus({ preventScroll: true });
      });
    }

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.dataset.shown = entries[0].isIntersecting ? 'false' : 'true';
    }, { rootMargin: '0px' }).observe(hero);
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setupReveal() {
    var targets = root.querySelectorAll('.reveal');
    if (prefersReduced() || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        var node = entry.target;
        window.setTimeout(function () { node.classList.add('is-in'); }, i * 100);
        io.unobserve(node);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
